import { Props_SnippetAccordion } from "./Accordion.props";
import SnippetLink from '../Shared/Link/Link';
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const Accordion = (props: Props_SnippetAccordion ) => {
    const { heading, repeatable_accordionRow } = props;

    const classHeadingVisibility: string = heading.visibility?.value === "hidden" ? ` snippet-accordion__heading--${heading.visibility.value}`: '';

    return (
        <section className="snippet-accordion">
            <div className="snippet-accordion__container">
                <h2 className={`snippet-accordion__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                <div className="snippet-accordion__row-container">
                    {repeatable_accordionRow.map((accordionRow, index) => {
                        const {linkContent, linkHref, linkStyle, linkTarget, title, text} = accordionRow; 

                        return (
                            <details
                                key={"accordion-row-" + index}
                                className="snippet-accordion__row"
                                name="accordion-row"
                            >
                                { title?.value && <summary className="snippet-accordion__row-title">{title.value}</summary> }
                                <div className="snippet-accordion__content-container">
                                    { text?.value && <div className="snippet-accordion__content">
                                        {CompileMarkdown(text.value)}
                                    </div> }
                                    <SnippetLink 
                                        linkStyles={linkStyle?.value} 
                                        className="snippet-accordion__link" 
                                        url={linkHref?.value}
                                        target={linkTarget?.value}
                                    >
                                        {linkContent?.value}
                                    </SnippetLink>
                                </div>
                            </details>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Accordion;
